import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PregnantWomanIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pregnant_woman"}/>
}
